import React, { Component } from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import { withRouter } from 'react-router-dom';
import createGroupItem from './GroupsSearchItem';

/**
 * hoc для автоматизации управления универсальным reducer list и состоянием location search
 * - при изменении в store подготовленных параметров к отправке запроса, компонент вызывает запрос
 * - при изменении location search компонент меняет параметры запроса в store и вызывает запрос
 * */
export default function createGroup(WrappedComponent) {
  class SingleSearchCollector extends Component {
    constructor(props) {
      super(props);
      this.queryParams = qs.parse(this.props.location.search.slice(1));
      this.componentItem = createGroupItem(WrappedComponent);
    }

    setGroupQueryParamsAndUpdateHistory = queryParams => {
      this.queryParams = queryParams;
      this.updateHistory();
    };

    removeGroupQueryParamsAndUpdateHistory = () => {
      this.queryParams = null;
    };

    updateHistory = () =>
      this.context.router.history.push({
        pathname: this.props.location.pathname,
        search: `?${qs.stringify(this.queryParams)}`
      });

    render() {
      const Content = this.componentItem;
      return (
        <Content
          {...this.props}
          groupName={null}
          searchString={`?${qs.stringify(this.queryParams)}`}
          setGroupQueryParamsAndUpdateHistory={
            this.setGroupQueryParamsAndUpdateHistory
          }
          removeGroupQueryParamsAndUpdateHistory={
            this.removeGroupQueryParamsAndUpdateHistory
          }
        />
      );
    }
  }
  SingleSearchCollector.displayName = `SingleSearchCollector`;
  SingleSearchCollector.propTypes = {
    location: PropTypes.shape({
      search: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired
    }).isRequired
  };
  SingleSearchCollector.contextTypes = {
    router: PropTypes.shape()
  };
  return withRouter(SingleSearchCollector);
}



// WEBPACK FOOTER //
// ./src/components/Hocs/GroupsSearchNewCollector/SingleSearchItem.js